import { Component, OnInit ,ChangeDetectorRef,ChangeDetectionStrategy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from "../../services/users.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from "@angular/router";
import { Subject, interval } from 'rxjs';
@Component({
  selector: 'app-viewer-details',
  templateUrl: './viewer-details.component.html',
  styleUrls: ['./viewer-details.component.scss']
})
export class ViewerDetailsComponent implements OnInit {
  userLoginData:any=[];assId:any='';assData:any=[];course_id:any='';module_id:any='';submodule_id:any='';assessmentType:any='';
  getModulSubData:any=[];moduleStatus:any=0;moduleName:any='';
  courseData: any;
  constructor(private changeDetector: ChangeDetectorRef,private _formBuilder: FormBuilder,private router: Router,private authUser: UsersService,private route: ActivatedRoute,private spinner: NgxSpinnerService,
    private modalService: NgbModal) { 
    if (localStorage.getItem('userLoginData') =='' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
  }
  ngOnInit(): void {
    localStorage.removeItem('ModulSubData');
    localStorage.removeItem('moduleName');
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.assId = queryParams['assId'];
      this.course_id = queryParams['course_id'];
      this.module_id = queryParams['module_id'];
      this.submodule_id = queryParams['submodule_id'];
      this.assessmentType = queryParams['AT'];
    });
    this.checkCoursesStatus(this.userLoginData.user_id,this.course_id);
    if(this.assId !='' || this.assId !=null){ this.assessmentDetail(this.assId)}
    this.getModuleDetails(this.module_id,this.submodule_id);
    if(this.submodule_id !=''){
      this.moduleStatus = 1;
      this.getModulSubDetails(this.module_id,this.submodule_id);
    }
    if(this.course_id){
      this.getCourseData(this.course_id);
    }
    
  }
  /****incase admin make course deactive than check and redirect to assign list */
  checkCoursesStatus(user_id:number,course_id:any){
    this.spinner.show();
    this.authUser.checkCourseStatus(user_id,course_id).subscribe(
      data=>{
      if(data.exits == 0){
        this.router.navigateByUrl('/assigned'); 
      }
      this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  assessmentDetail(assId:any){
    this.authUser.assessmentData(assId,this.userLoginData.user_id,this.course_id).subscribe(
      data=>{
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        }else{
          this.assData = data.data;
        }
      },error=>{
      }
    )
  }
  open1(content: any) { 
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false  }); 
  }
  getCourseData(course_id:any){
    this.authUser.getCourseData(course_id).subscribe(
       data => {
        // if(data.status == 401){
        //   document.getElementById('successMsg')?.click();
        //   this.spinner.hide();
        // }else{
          this.courseData=data
          localStorage.setItem('CourseData', JSON.stringify(data.course.course_name ));
        //}
       }, error => {
        // console.log(error);
       }
     )
  }
  getModulSubDetails(module_id:any,submodule_id:any){
    this.spinner.show();
    this.authUser.getModulSubDetail(module_id,submodule_id,this.course_id).subscribe(
      data=>{
        // if(data.status == 401){
        //   document.getElementById('successMsg')?.click();
        //   this.spinner.hide();
        // }else{
          this.getModulSubData = data.data;
          localStorage.setItem('ModulSubData', JSON.stringify(this.getModulSubData ));
          this.spinner.hide();
       // }
        
      },error=>{
        this.spinner.hide();
      }
    )
  }
  getModuleDetails(module_id:any,submoduleId:any){
    this.spinner.show();
    this.authUser.getModuleDetail(module_id).subscribe(
      data => {
        // if(data.status == 401){
        //   document.getElementById('successMsg')?.click();
        //   this.spinner.hide();
        // }else{
          this.moduleName = data.data.module_name;
          localStorage.setItem('moduleName', JSON.stringify(this.moduleName));
          this.spinner.hide();
       // }
      }, error => {
        this.spinner.hide();
      }
    )
  }
  startAssessments(){
    this.authUser.startAssessment(this.userLoginData.user_id,this.course_id,this.assId).subscribe(
      data=>{
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        }else if(data.status == 200){
        this.router.navigate(['/viewer_question'], { queryParams: {courseId:this.course_id,moduleId:this.module_id,submoduleId:this.submodule_id,assId:this.assId,AT:this.assessmentType} });
        }
      },error=>{
       // console.log(error);
      }
    )
  }
  navigationEvent() {
    localStorage.removeItem('userLoginData');
    this.router.navigateByUrl('/'); 
    
    }
}
